// @ts-strict-ignore
import * as React from 'react';
import Alert from 'antd/lib/alert';
import Space from 'antd/lib/space';
import { colorWithAlpha, runwayColors, rwColors } from './styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import { ResponsiveDrawer } from './buildDistribution/mobileComponents/ResponsiveDrawer';
import AuthedUrlButton from './authedUrlButton/AuthedUrlButton';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';
import { selectOrg } from '../selectors/selectors';
import { PlusOutlined } from '@ant-design/icons';
import { RunwayUserAction } from '@/helpers/aclHelpers';

export const InstructionSteps: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 16, margin: '16px 0' }}>
            {/* // iterate over children and add a step number */}
            {React.Children.map(children, (child, index) => {
                return (
                    <Space style={{ width: '100%' }} size={16} align="baseline">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: 24,
                                width: 24,
                                backgroundColor: runwayColors.primary,
                                borderRadius: 12,
                            }}
                        >
                            <Text strong style={{ textAlign: 'center', color: runwayColors.white }}>
                                {index + 1}
                            </Text>
                        </div>
                        {child}
                    </Space>
                );
            })}
        </div>
    );
};

export interface RegisterDeviceInstructionsProps {
    isClosable?: boolean;
}

export const RegisterDeviceInstructions: React.FC<RegisterDeviceInstructionsProps> = () => {
    const orgId = useSelector((state: RootState) => selectOrg(state).id);

    const addDeviceEndpoint = `https://distro.runway.team/api/org/${orgId}/user/device/add`;

    return (
        <Alert
            style={{
                padding: 16,
                borderColor: colorWithAlpha(rwColors.primary, 0.25),
            }}
            description={
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16,
                        width: '100%',
                    }}
                >
                    <Text strong style={{ textAlign: 'center', width: '100%' }}>
                        Registering your personal device
                    </Text>
                    <InstructionSteps>
                        <Text style={{ textAlign: 'center' }}>
                            Tap the ‘Register this device now’ button shown below.
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            The system will prompt you to allow the download of a configuration profile. Tap ‘Allow’.
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            On this device, go to: <br />
                            <strong>Settings -{'>'} Profile Downloaded</strong>
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            Tap ‘Install’ on the ‘Runway Build Distro’ profile.{' '}
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            Return here and refresh the page to confirm that registration was successful.
                        </Text>
                    </InstructionSteps>
                    <AuthedUrlButton
                        type="primary"
                        actionType={RunwayUserAction.UAAddRemoveDevice}
                        icon={<PlusOutlined />}
                        linkUrl={addDeviceEndpoint}
                        style={{
                            width: '100%',
                        }}
                        onLinkAuthed={(authedLink) => window.open(authedLink, '_self')}
                    >
                        Register this device now
                    </AuthedUrlButton>
                </div>
            }
            type="info"
        />
    );
};

export interface RegisterDeviceInstructionsSheetProps {
    isOpen?: boolean;
    onClose?: () => void;
}
export const RegisterDeviceInstructionsSheet: React.FC<RegisterDeviceInstructionsSheetProps> = ({
    isOpen,
    onClose,
}) => {
    return (
        <ResponsiveDrawer
            header={null}
            open={isOpen}
            content={<RegisterDeviceInstructions />}
            onClose={onClose}
            heightRatio={0.85}
        />
    );
};
